export const ADD_EMAIL_LOADING = "ADD_EMAIL_LOADING";
export const ADD_EMAIL_SUCCESS = "ADD_EMAIL_SUCCESS";
export const ADD_EMAIL_FALED = "ADD_EMAIL_FALED";


export const GET_EMAIL_LOADING = "GET_EMAIL_LOADING";
export const GET_EMAIL_SUCCESS = "GET_EMAIL_SUCCESS";
export const GET_EMAIL_FALED =   "GET_EMAIL_FALED";